import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import { dispatchDataLayerEventOnClick } from '../../../../helpers/dataLayerHelpers/HomepageDataLayerHelper';
import { ContentfulStaticBanner } from '../../../../types/banner';
import type { Audience, AudienceProps } from '../../product-list/types';
import { HomePageBannerData } from '../types';

const HOMEPAGE_MAINBANNER = 'homepage_mainbanner';

const dispatchDataLayerEventOnMultiVariantBannerGA4 = (
  eventName: string,
  audienceType: Audience,
) => {
  const audience = audienceType || 'non-recognized';
  addDataLayerEntry(
    eventName,
    {
      content_type: (Boolean(audienceType) && audienceType !== 'no_audience')
        ? 'personalized' : 'non-personalized',
      audience_type: audience,
    },
  );
};

export const handleMultiVariantBannerClick = (
  audienceType: string | undefined,
) => {
  dispatchDataLayerEventOnMultiVariantBannerGA4('marketing_banner_click', audienceType);
};

export const dispatchDataLayerEventOnBannerClickGA4 = (eventName: string, campaignName: string | undefined) => {
  addDataLayerEntry(
    eventName,
    { campaignName },
  );
};
export const dispatchDataLayerHomepageBannerImpressionsGA4 = (
  bannerTitle: ContentfulStaticBanner['bannerTitle'],
) => {
  const eventName = 'view_promotion';
  addDataLayerEntry(
    eventName,
    {
      ecommerce: {
        bannerTitle,
      },
    },
  );
};
export const handleOnBannerClick = (bannerTitle: string | undefined) => {
  const eventPayload = {
    item: HOMEPAGE_MAINBANNER,
  };
  dispatchDataLayerEventOnClick(eventPayload);
  dispatchDataLayerEventOnBannerClickGA4(HOMEPAGE_MAINBANNER, bannerTitle);
};
export const observerCallbackBannerView = (
  inView: boolean,
  entry: IntersectionObserverEntry,
  bannerContent: HomePageBannerData | undefined,
  audiencesDataFromSegment: AudienceProps['audiencesDataFromSegment'],
  audienceOverRideForPlayground: AudienceProps['audienceOverRideForPlayground'],
) => {
  if (!(inView && entry.isIntersecting)) return;

  const bannerTitle = entry?.target?.attributes?.getNamedItem('data-banner-title')?.value || '';
  dispatchDataLayerHomepageBannerImpressionsGA4(bannerTitle);

  const audienceType = entry?.target?.attributes?.getNamedItem('data-audience-type')?.value || audiencesDataFromSegment?.type;
  if (bannerContent || audienceOverRideForPlayground || audienceType) {
    dispatchDataLayerEventOnMultiVariantBannerGA4('marketing_banner_view', audienceType);
  }
};
